import { marketShareColumns } from '../../market-share/constants/marketShareColumns';
import { chartFontFamily } from ".";

export const MAX_LINE_LENGTH = 220;

export const rowsPerPage = 16;
export const blankRowHeight = '3in';

export const paginationConfig = {
    "useDividerLine": false,
    "height": 10,
    "pagination": {
        "template": "Page {0} of {1}",
        "enabled": true,
        "font": {
            "size": 7,
            "family": "Helvetica",
            "style": "Regular",
            "hexColor": "#6B7280"
        },
        "coordinates": {
            "xPosition": 780,
            "yPosition": -20
        }
    }
};

export const styles = `body {
    font-family: 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif;
    line-height: 1.4;
}

.market-indicator-text {
    font-size: 50px;
    font-weight: bold;
    text-align: center;
}

.column-container-centered {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.agent-detail-page-section {
    padding-top: 375px;
}

.page-section {
    margin-top: 245px;
}

.table {
    page-break-before: always;
    page-break-inside: avoid;
    font-size: 28px;
    border-collapse: collapse;
    width: calc(100% - 56px);  
    margin-left: 25px;
    margin-right: 30px; 
}

.totals-row {
    border-top: 1px solid #D1D5DB;
}

.table tr {
    text-wrap: nowrap;
}

.table th {
    text-transform: uppercase;
    padding: 4px 4px;  
    border-bottom: 1px solid #D1D5DB;
    border-right: 1px solid #D1D5DB;
    border-left: 1px solid #D1D5DB;
    text-align: left;
    color: #6B7280;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-wrap: wrap;
}

.table td {
    padding: 10px 4px;
    border-right: 1px solid #D1D5DB;
    border-left: 1px solid #D1D5DB;
    text-align: left;
}
.table tr:nth-child(even) {
    background-color: #F9FAFB;
}
.table th.right,
.table td.right {
    text-align: right;
}
.table td.totals-row-title {
    font-weight: bold;
}
.table.agent-detail-table {
    border-top: 1px solid #D1D5DB;
}

.table.agent-detail-table th {
    padding-top: 20px;
    padding-bottom: 20px;
    border-left: none;
    border-right: none;
}
.table.agent-detail-table td {
    border-left: none;
    border-right: none;
}
.header {
    position: fixed;
    top: 20px;
    left: 30px;
    right: 30px;
}
.contact-info {
   font-size: 25px;
}
.contact-item {
    display: inline-block;
    margin-right: 15px;
}
.office-name, .agent-name, .summary-table-title,
.summary-table-cards-container div>p {
    font-size: 30px;
}
.address, .agent-id {
    font-size: 25px;
}
.header-divider {
    border-top: 1px solid #D1D5DB;
    margin-bottom: 5px;
    margin-top: 0;
    margin-left: -30px;
    margin-right: -30px;
}
.footer-divider {
    border-top: 1px solid #D1D5DB;
    margin-bottom: 5px;
    margin-left: -30px;
    margin-right: -30px;
}
.header-title-separator {
    display: inline-block;
    width: 1px;
    height: 50px;
    background-color: #D1D5DB;
    margin: 0 10px;
    vertical-align: middle;
}
.header-title-container {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 10px;
    width: 100%;
}
.header-title {
    font-size: 40px;
    font-weight: bold;
    text-transform: capitalize;
}
.header-subtitle {
    font-size: 30px;
    color: #4B5563;
    margin-right: 10px;
}
.footer {
    position: fixed;
    bottom: 30px;
    left: 30px;
    right: 30px;
    font-size: 20px;
    color: #6B7280;
}
.footer-content {
    display: flex;
    flex-direction: column;
}
.agent-profile-chart-container {
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 4in;
}
.agent-profile-chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 40px;
}
.market-dynamics-chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 4in;
}
.chart-container,
.market-dynamics-chart-container {
    margin-left: 30px;
    margin-right: 30px;
}
.chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 4in;
}
.overview-report img {
    margin-top: 3in;
}

.chart-wrapper {
    margin-top: 4in;
}

.chart-wrapper .area-header,
.chart-wrapper .chart-container {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 10px; 
    font-size: 30px;
    text-align: center;
}

.chart-wrapper .area-header {
    margin-bottom: 10px; 
    font-size: 30px;
    text-align: center;
}

.chart-wrapper .chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 0;
}

.dashboard-container {
    margin: auto;
    height: 700px;
    width: 100%;
    justify-content: center;
}    
.dashboard-container img {
    max-width: 100%;
    max-height: 100%;
}
.summary-table-container {
    border: solid 1px #D1D5DB;
    width: 100%;
    font-size: 25px;
}
.summary-table-title {
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;
    border: solid 1px #D1D5DB;
    border-top: none;
}
.summary-table-cards-container {
    display: flex;
}
.summary-table-card {
    width: 20%;
    text-align: center;
    border: solid 1px #D1D5DB;
    border-top: none;
    border-right: none;
    padding: 10px;
}
.summary-table-card > p {
    font-weight: bold;
    margin: 0 0 10px 0;
}
.page-content {
    page-break-after: always;
}
.page-content:last-child {
    page-break-after: avoid;
}
.disclaimer {
    padding-top: 17px;
    font-size: 20px;
    color: #6B7280;
    max-width: 80%;
}
.contact-icon {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 4px;
}
.contact-item {
   font-size: 25px;
}
.contact-icon path {
  fill: currentColor;
}
.blank-row {
    page-break-before: always;
}
.report-details {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 0;
}
.detail-line {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0 15px;
}
.detail-item {
    display: inline-block;
    white-space: nowrap;
}
.office-list-footer {
    text-transform: capitalize;
}    
.full-width {
    width: 100%;
}
.date {
   position: fixed;
   bottom: 66px;
   right: 215px;
   font-size: 22px;
}
.description-text {
   font-size: 25px;
}
.agent-info-container {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}
.additional-agent-info {
    display: flex;
    justify-content: space-between;
    font-size: 25px;
}
.additional-agent-info > * {
    text-align: right;
    margin-left: 30px;
}
.logo-pdf {
    position: fixed;
    top: 45px;
    right: 40px;
    height: auto;
    width: auto;
}
.office-name-padded {
    display: block;
    padding-bottom: 48px;
}`;

export const fieldsToExclude = [
    marketShareColumns.isSelected.id,
    marketShareColumns.rank.id,
    marketShareColumns.streetName1.id,
    marketShareColumns.city.id,
    marketShareColumns.stateCode.id,
    marketShareColumns.zipCode.id,
    marketShareColumns.county.id,
    marketShareColumns.phoneNumber.id,
];

export const pdfChartLabelStyles = {
    colors: ['#000000'],
    fontFamily: chartFontFamily,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '16px',
};

export const pdfChartTitleStyles = {
    color: '#000000',
    fontFamily: chartFontFamily,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '16px',
};

export const getAgentDetailsFileName = ({ agentName, mlsName, periods, selectedTabLabel }) => {
    return `${agentName}’s ${selectedTabLabel} in ${mlsName}${periods ? ` for ${periods}` : ''}.pdf`.replace(/\s+/g, ' ');
};
